import { classNames } from '../../../utils/helpers';

export default function SkeletonLoader( { count = 6, columnsDesktop = 3, columnsTablet = 2, columnsMobile = 1, gap = 24, gapTablet = 16, gapMobile = 12 } ) {
	return (
		<div
			className={ classNames( 'mwsb-grid', `mwsb-cols-${ columnsDesktop }`, `mwsb-cols-tablet-${ columnsTablet }`, `mwsb-cols-mobile-${ columnsMobile }` ) }
			style={ {
				'--mwsb-gap':        `${ gap }px`,
				'--mwsb-gap-tablet': `${ gapTablet }px`,
				'--mwsb-gap-mobile': `${ gapMobile }px`,
			} }
		>
			{ Array.from( { length: count } ).map( ( _, i ) => (
				<div key={ i } className="mwsb-skeleton-card">
					<div className="mwsb-skeleton mwsb-skeleton--image" />
					<div className="mwsb-skeleton-body">
						<div className="mwsb-skeleton mwsb-skeleton--title" />
						<div className="mwsb-skeleton mwsb-skeleton--price" />
						<div className="mwsb-skeleton mwsb-skeleton--btn" />
					</div>
				</div>
			) ) }
		</div>
	);
}
